/** MOS date-range keys shared by Care Portal filters and the metrics GET. */
export const MANAGER_OPERATING_SYSTEM_DATE_RANGE_VALUES = [
  'yesterday',
  'last7Days',
  'monthToDate',
  'lastMonth',
] as const;

/** MOS date-range selection accepted by the metrics GET. */
export type ManagerOperatingSystemDateRange =
  (typeof MANAGER_OPERATING_SYSTEM_DATE_RANGE_VALUES)[number];

/** Default MOS date range used when the query does not specify one. */
export const DEFAULT_MANAGER_OPERATING_SYSTEM_DATE_RANGE =
  'monthToDate' satisfies ManagerOperatingSystemDateRange;

/** Sentinel representing every available team or customer in MOS filters. */
export const MANAGER_OPERATING_SYSTEM_ALL_FILTER_VALUE = 'all';
